import { render } from "./mIndex3.vue?vue&type=template&id=e473550a&scoped=true"
import script from "./mIndex3.vue?vue&type=script&lang=js"
export * from "./mIndex3.vue?vue&type=script&lang=js"

import "./mIndex3.vue?vue&type=style&index=0&id=e473550a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e473550a"]])

export default __exports__